import { SET_SIV_ERROR, CLEAR_SIV_ERROR } from "../../actions/app/pay/pay.action";

export const sivErrorReducer = (sivError = false, action) => {
    const { payload } = action;

    switch (action.type) {
        case SET_SIV_ERROR:
            return payload;

        case CLEAR_SIV_ERROR:
            return false;

        default:
            return sivError;
    }
};